var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.814,
    height: 13.838,
    viewBox: "0 0 15.814 13.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(86 -3.178)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-86 3.178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.843,3.238H1.982a.988.988,0,0,0-.988.988v9.884a.988.988,0,0,0,.988.988H13.843a.988.988,0,0,0,.988-.988V4.227a.988.988,0,0,0-.988-.988ZM1.982,2.25A1.977,1.977,0,0,0,0,4.227v9.884a1.977,1.977,0,0,0,1.977,1.977H13.843a1.977,1.977,0,0,0,1.977-1.977V4.227A1.977,1.977,0,0,0,13.843,2.25H1.982Z",
    transform: "translate(-0.005 -2.25)",
    fill: "#999",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.789,17.019a.494.494,0,0,1,.57-.092l3.734,1.925V23.3H2.255V21.323L4.871,19a.494.494,0,0,1,.622-.062l2.629,1.752,3.667-3.667Z",
    transform: "translate(-1.267 -10.45)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.238,11.965a1.483,1.483,0,1,0-1.483-1.483A1.483,1.483,0,0,0,8.238,11.965Z",
    transform: "translate(-3.79 -6.035)",
    fill: "#999",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.f433ef596a10fc92e6e56a3f367b5b12.svg";
export { ForwardRef as ReactComponent };